export const QuarterTile = ({ children }) => {
    return (
        <div className='col-xs-6 col-sm-6 col-md-6 padding-0'>
            {children}
        </div>
    );
};

export default QuarterTile;
